import {IUserProfile} from "../types/IUserProfile";

export const checkHasCompleteProfile = (userProfile: IUserProfile | null | undefined): boolean => {
    return Boolean(userProfile && userProfile.name && userProfile.phone);
};
import {IUserProfile} from "../types/IUserProfile";

export const checkHasCompleteProfile = (userProfile: IUserProfile | null | undefined): boolean => {
    return Boolean(userProfile && userProfile.name && userProfile.phone);
};
